import axios from 'axios';

// const URL = process.env.REACT_APP_STAGE === 'production'
//   ? 'https://prenuvo.com'
//   : 'http://localhost'

export const api = axios.create({
  timeout: 45000,
  responseType: 'json'
})